import { productListFilterAccordionSectionStyles as styles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.accordionSection = {
    ...styles.accordionSection,
    headerProps: {
        ...styles.accordionSection?.headerProps,
        css: css`
            ${styles.accordionSection?.headerProps?.css}

            button {
                padding: 16px;
                border: 1px solid ${getColor(colorStrings.commonBorder)};
                span {
                    color: ${getColor(colorStrings.commonGlobalBlack)};
                }
                ${IconWrapper} {
                    color: ${getColor(colorStrings.primaryMain)};
                }
            }

            &&&& {
                button {
                    &:focus {
                        padding: 16px;
                    }
                }
            }
        `,
    },

    panelProps: {
        ...styles.accordionSection?.panelProps,
        css: css`
            ${styles.accordionSection?.panelProps?.css}
            padding: 16px;
            border: 1px solid ${getColor(colorStrings.commonBorder)};
            border-radius: none;
            ${mediaQueriesBP.maxMD} {
                padding: 16px;
            }
            ${mediaQueriesBP.minMD} {
                padding: 16px;
            }
        `,
    },

    mergeCss: true,
};
